export const routes = Object.freeze({
    home: '/home',
    products: '/products',
    pricing: '/pricing',
    contact: '/contact',
});
